/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Sort_Amount_DescInputs */



/**
* | output |
* | --- |
* | "amount due, high to low" |
*
* @param {Partner_Billing_Board_Sort_Amount_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_sort_amount_desc = /** @type {((inputs?: Partner_Billing_Board_Sort_Amount_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Sort_Amount_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Betrag, absteigend")
	return /** @type {LocalizedString} */ ("amount due, high to low")
});